import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {BzButton, BzIcon} from "@bringoz/ui";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {FormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {VisitPlanInfoTooltipComponent} from "./components/visit-plan-info-tooltip/visit-plan-info-tooltip.component";
import {VisitPlanExtendedServiceTimesTooltipComponent} from "./components/visit-plan-extended-service-times-tooltip/visit-plan-extended-service-times-tooltip.component";

import {VisitPlanCardInfoComponent} from "./components/visit-plan-card-info/visit-plan-card-info.component";
import {VisitPlanStatusComponent} from "./components/visit-plan-status/visit-plan-status.component";
import {
  VisitPlanAccountsTableComponent
} from "./components/visit-plan-accounts-table/visit-plan-accounts-table.component";
import {
  VisitPlanAccountsTableRowComponent
} from "./components/visit-plan-accounts-table-row/visit-plan-accounts-table-row.component";
import {
  VisitPlanAccountsTableRowCellComponent
} from "./components/visit-plan-accounts-table-row-cell/visit-plan-accounts-table-row-cell.component";
import {VisitPlanCallDetailsComponent} from "./components/visit-plan-call-details/visit-plan-call-details.component";
import {
  VisitConfigurationsTableComponent
} from "./components/visit-configurations-table/visit-configurations-table.component";
import {
  VisitConfigurationsTableRowComponent
} from "./components/visit-configurations-table-row/visit-configurations-table-row.component";
import {ServicesModule} from "../../deliveries/angular/services.module";
import {CellEditDialogComponent} from "./components/cell-edit-dialog/cell-edit-dialog.component";
import {SubTasksModule} from "../../sub-tasks/angular/sub-tasks.module";
import {
  VisitPlanTrackerChangesViewComponent
} from "./components/visit-plan-tracker-changes-view/visit-plan-tracker-changes-view.component";
import {AccountsModule} from "../../account/angular/accounts.module";
import {AgentsModule} from "../../agents/angular/agents.module";
import {VisitPlanJobsPanelComponent} from "./components/visit-plan-jobs-panel/visit-plan-jobs-panel.component";
import {ScrollingModule as ScrollingModuleExperimental} from "@angular/cdk-experimental/scrolling";
import {
  VisitPlanJobsPanelItemComponent
} from "./components/visit-plan-jobs-panel-item/visit-plan-jobs-panel-item.component";
import {
  VisitPlanScheduleResourceSelectListComponent
} from "./components/visit-plan-schedule-resource-select-list/visit-plan-schedule-resource-select-list.component";
import {VisitPlanPanelsComponent} from "./components/visit-plan-panels/visit-plan-panels.component";
import {
  VisitPlanJobsPanelFiltersDialogComponent
} from "./components/visit-plan-jobs-panel-filters-dialog/visit-plan-jobs-panel-filters-dialog.component";
import {BranchesModule} from "../../branches/angular/branches.module";
import {
  VisitScheduleAgentsListComponent
} from "./components/visit-schedule-agents-list/visit-schedule-agents-list.component";
import {
  VisitPlanDaySelectDialogComponent
} from "./components/visit-plan-day-select-dialog/visit-plan-day-select-dialog.component";
import {VisitPlanRoutesPanelComponent} from "./components/visit-plan-routes-panel/visit-plan-routes-panel.component";
import {
  VisitPlanRoutesPanelListComponent
} from "./components/visit-plan-routes-panel-list/visit-plan-routes-panel-list.component";
import {
  VisitPlanRoutesPanelListItemComponent
} from "./components/visit-plan-routes-panel-list-item/visit-plan-routes-panel-list-item.component";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {
  VisitPlanAccountSortingDialogComponent
} from "./components/visit-plan-account-sorting-dialog/visit-plan-account-sorting-dialog.component";
import {
  OptimizationDaySelectDialogComponent
} from "./components/optimization-day-select-dialog/optimization-day-select-dialog.component";
import {
  VisitPlanMetricWidgetComponent
} from "./components/visit-plan-metric-widget/visit-plan-metric-widget.component";
import {TasksModule} from "../../tasks/angular/tasks.module";
import {MapModule} from "../../map/angular/map.module";
import {VisitPlanJobsMapComponent} from "./components/visit-plan-jobs-map/visit-plan-jobs-map.component";
import {GoogleMapsModule} from "@angular/google-maps";
import {AvailabilityTableComponent} from "./components/availability-table/availability-table.component";
import {AvailabilityTableRowComponent} from "./components/availability-table-row/availability-table-row.component";
import {AvailabilityTableCellComponent} from "./components/availability-table-cell/availability-table-cell.component";
import {AssignAvailabilityDialogComponent} from "./components/assign-availability-dialog/assign-availability-dialog.component";
import {AgentsHttpService} from "../../agents/angular/services/agents-http.service";
import {HttpClientModule} from "@angular/common/http";
import {
  VisitPlanTableColumnFilterDialogComponent
} from "./components/visit-plan-table-column-filter-dialog/visit-plan-table-column-filter-dialog.component";
import {
  VisitPlanRouteTasksPanelListComponent
} from "./components/visit-plan-route-tasks-panel-list/visit-plan-route-tasks-panel-list.component";
import {
  VisitPlanRouteTasksPanelListItemComponent
} from "./components/visit-plan-route-tasks-panel-list-item/visit-plan-route-tasks-panel-list-item.component";
import {
  EditAvailabilityDialogComponent
} from "./components/edit-availability-dialog/edit-availability-dialog.component";
import {
  AvailabilityLocationPointComponent
} from "./components/availability-location-point/availability-location-point.component";
import {
  VisitPlanScheduleRouteReassignmentComponent
} from "./components/visit-plan-schedule-route-reassignment/visit-plan-schedule-route-reassignment.component";
import {
  VisitPlanRoutesPanelContextMenuComponent
} from "./components/visit-plan-routes-panel-context-menu/visit-plan-routes-panel-context-menu.component";
import {
  VisitScheduleAgentImportDialogComponent
} from "./components/visit-schedule-agent-import-dialog/visit-schedule-agent-import-dialog.component";
import {
  VisitPlanAutoDispatchDialogComponent
} from "./components/visit-plan-auto-dispatch-dialog/visit-plan-auto-dispatch-dialog.component";
import {
  VisitPlanExternalAgentsResourceHoldersList
} from "./components/visit-plan-external-agents-resource-holders-list/visit-plan-external-agents-resource-holders-list.component";
import {
  VisitPlanExternalAgentsResourceHoldersSingleSelectList
} from "./components/visit-plan-external-agents-resource-holders-single-select-list/visit-plan-external-agents-resource-holders-single-select-list.component";
import {
  VisitPlanResourceHoldersMultiSelectComponent
} from "./components/visit-plan-resource-holders-multi-select/visit-plan-resource-holders-multi-select.component";
import {
  VisitPlanResourceHoldersMultiSelectListComponent
} from "./components/visit-plan-resource-holders-multi-select-list/visit-plan-resource-holders-multi-select-list.component";
import {RecommendationModule} from "../../recommendation/angular/recommendation.module";
import {ServicePointsModule} from "../../service-points/angular/service-points.module";
import {
  $branchesProvider,
  $stateServiceProvider,
  $windowServiceProvider,
  analyticsServiceProvider
} from "../../../providers";
import {
  SchedulingProjectReportsTableComponent
} from "./components/scheduling-project-reports-table/scheduling-project-reports-table.component";
import {
  VisitPlanAuditLogComponent
} from "./components/visit-plan-audit-log/visit-plan-audit-log.component";
import {
  SchedulingProjectVisitPlansTableComponent
} from "./components/scheduling-project-visit-plans-table/scheduling-project-visit-plans-table.component";


@NgModule({
  declarations: [
    VisitPlanCardInfoComponent,
    VisitPlanStatusComponent,
    VisitPlanAccountsTableComponent,
    VisitPlanAccountsTableRowComponent,
    VisitPlanAccountsTableRowCellComponent,
    VisitPlanCallDetailsComponent,
    VisitPlanInfoTooltipComponent,
    VisitPlanExtendedServiceTimesTooltipComponent,
    VisitConfigurationsTableComponent,
    VisitConfigurationsTableRowComponent,
    CellEditDialogComponent,
    VisitPlanTrackerChangesViewComponent,
    VisitPlanJobsPanelComponent,
    VisitPlanJobsPanelItemComponent,
    VisitPlanScheduleResourceSelectListComponent,
    VisitPlanPanelsComponent,
    VisitPlanJobsPanelFiltersDialogComponent,
    VisitScheduleAgentsListComponent,
    VisitPlanDaySelectDialogComponent,
    VisitPlanRoutesPanelComponent,
    VisitPlanRoutesPanelListComponent,
    VisitPlanRouteTasksPanelListComponent,
    VisitPlanRouteTasksPanelListItemComponent,
    VisitPlanRoutesPanelListItemComponent,
    VisitPlanAccountSortingDialogComponent,
    OptimizationDaySelectDialogComponent,
    VisitPlanTableColumnFilterDialogComponent,
    VisitPlanMetricWidgetComponent,
    VisitPlanJobsMapComponent,
    AvailabilityTableComponent,
    AvailabilityTableRowComponent,
    AvailabilityTableCellComponent,
    AssignAvailabilityDialogComponent,
    EditAvailabilityDialogComponent,
    AvailabilityLocationPointComponent,
    VisitPlanRoutesPanelContextMenuComponent,
    VisitPlanScheduleRouteReassignmentComponent,
    VisitScheduleAgentImportDialogComponent,
    VisitPlanAutoDispatchDialogComponent,
    VisitPlanExternalAgentsResourceHoldersList,
    VisitPlanExternalAgentsResourceHoldersSingleSelectList,
    VisitPlanResourceHoldersMultiSelectComponent,
    VisitPlanResourceHoldersMultiSelectListComponent,
    SchedulingProjectReportsTableComponent,
    VisitPlanAuditLogComponent,
    SchedulingProjectVisitPlansTableComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forRoot(),
    FormsModule,
    NgSelectModule,
    ServicesModule,
    SubTasksModule,
    AccountsModule,
    AgentsModule,
    ScrollingModule,
    DragDropModule,
    ScrollingModuleExperimental,
    BranchesModule,
    TasksModule,
    AgentsModule,
    GoogleMapsModule,
    MapModule,
    RecommendationModule,
    ServicePointsModule,
    BzButton,
    BzIcon
  ],
  providers: [
    AgentsHttpService,
    $branchesProvider,
    $stateServiceProvider,
    $windowServiceProvider,
    analyticsServiceProvider
  ],
  exports: [
    VisitPlanMetricWidgetComponent
  ]
})

export class SchedulingProjectModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapSchedulingProjectModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(SchedulingProjectModule);
};

export const downgradedSchedulingProjectModule = downgradeModule(bootstrapSchedulingProjectModule);
